import { 
	Field,
	connect as formikConnect, 
	FieldArray 
} from 'formik'
import React from 'react'
import uuidv1 from 'uuid/v1'

import TimesheetLine from './TimesheetLine'
import { getEmptyTimesheetLine } from '@modules/timesheet/timesheet.module'

@formikConnect
class TimesheetLineArrayField extends React.Component {
	render() {
		const { name, formik, isEditing } = this.props;
		const values = formik.values[this.props.name];
	  return (
	  	<FieldArray name={name} render={arrayHelpers => (
	  		<div className="TimesheetLineArray">
		  		{	
						values.map((v, i) => (
							<div className="FieldLine" key={v._id || v.key}>
								<div className="FieldLine-header">
									<i>Timesheet Shift {i+1} </i>
									{
										isEditing
										&& <button type="button" className="btn btn-primary" onClick={() => {
											arrayHelpers.remove(i)
										}}>Remove</button>
									}
								</div>
								<Field 
									name={`${this.props.name}.${i}`} 
									component={TimesheetLine} 
									isEditing={isEditing}
								/>
							</div>
						))
					}
					{
						isEditing
						&& <button type="button" className="btn btn-primary" onClick={() => arrayHelpers.push(getEmptyTimesheetLine(uuidv1()))}>Add shift</button>
					}
				</div>
	  	)} />
	  )
	}
}

export default TimesheetLineArrayField;


// WEBPACK FOOTER //
// ./src/modules/form/components/input/TimesheetLineArray.jsx